import Const from 'const.json'
import { ChartLineDetails } from 'types/Chart';

let chartDetails: ChartLineDetails[];
const weight = 'bold'

export const chartOptions = (details: ChartLineDetails[], isContrast: boolean) => {
    chartDetails = details;
    return {
        scales: {
            x: {
                ticks: { color: isContrast ? '#00FFFF' : 'gray', },
                grid: { display: false },
                title: {
                    display: true, text: Const.months, color: isContrast ? 'white' : 'gray', align: 'center', font: { size: 14, weight }
                }
            },
            y: {
                ticks: { color: isContrast ? '#00FFFF' : 'gray', },
                beginAtZero: true,
                title: { display: true, text: Const.chartBarYAxisHeader, color: isContrast ? 'white' : 'gray', align: 'end', font: { size: 14, weight } },
            }
        },
        plugins: {
            tooltip: {
                enabled: false // Disable tooltips here
            },
            datalabels: {
                display: true,
                color: isContrast ? 'white' : 'black',
                font: { weight },
                anchor: 'end',
                clamp: false,
                align: 'top',
                position: 'center',
            },
            legend: {
                rtl: true,
                reverse: true,
                labels: {
                    color: isContrast ? 'white' : '#20285C',
                    boxHeight: 0,
                    
                },

                position: 'bottom',
                align: 'start'
            }
        },

        responsive: true,
        maintainAspectRatio: false,
    };
};

export const getLineDataWithDesign = (isContrast: boolean) => {
    const lineDataWithDesighn = chartDetails?.map((dataset, index) => {
        const borderColor = isContrast ? getAccessibleContrastColor(index) : getRandomBlueColor();
        return ({
            ...dataset,
            borderColor: borderColor,
            backgroundColor: borderColor,
            borderDash: getBorderDash(dataset.label.length, index),
        })
    });
    return lineDataWithDesighn;
}

const getAccessibleContrastColor = (index: number) => {
    const contrastColors = ['#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#FF00FF', '#00FFFF', '#FFA500', '#800080'];
    return contrastColors[index % contrastColors.length];
}

const getRandomBlueColor = () => {
    const h = 214;
    const s = Math.floor(Math.random() * 30 + 50);
    const l = Math.floor(Math.random() * 30 + 50);
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
}
const getBorderDash = (length: number, i: number) => {
    return [(length - i - 1) * 3, (length - i - 1) * 3]

}